import React, { useEffect } from "react";
import MaterialTable from 'material-table';

// reactstrap components
import { Button, Card, CardBody, Row, Col, Container } from "reactstrap";

// style
import { table_translate } from "../../../constants/MaterialTable.js";

// services
import { showMessage } from "../../../services/message.js";
import { api_POST } from "../../../services/api_service.js";

//Context
import { useAuth } from "../../../context/auth";

export default function ListaLocaisExclusao({ item, protocolo, handleProximoStep }) {
    const {setLoading} = useAuth();

    const [registro, set_registro] = React.useState(null);

    const [locais, set_locais] = React.useState([]);
    const [locaisExcluir, setLocaisExcluir] = React.useState([]);

    const loadItemRequerimento = () => {
        set_registro(item);
        if (protocolo != null && protocolo.protocoloDestino[0].protocoloDestinoLocais != null) {
            set_locais(protocolo.protocoloDestino[0].protocoloDestinoLocais);
        }
        if (item != null && item.requerimentoDestinoLocais != null) {
            setLocaisExcluir(item.requerimentoDestinoLocais);
        }
    }

    useEffect(() => {
        loadItemRequerimento();
    }, [protocolo]);

    const handleAvancar = () => {
        if (locaisExcluir.length == 0) {
            showMessage("Aviso", "Selecione os locais que deseja excluir!", 'error', null);
            return;
        }

        let json_submit = [];
        locaisExcluir.map(m => {
            json_submit.push(m.protocoloDestinoLocal_Id);
        })

        setLoading(true);
        api_POST(`requerimentoDestino/PostRequerimentoDestinoExclusaoLocal/${registro.requerimento_Id}`, json_submit)
            .then(result => handleProximoStep(registro))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    return (
        <>
            <div>

                <Card className="card-stats">
                    <CardBody>
                        <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                            <h2 className="titulo-solicitacao">Locais</h2>
                            <div className="formPrincipal">
                                <Row>
                                    <Col md="12">
                                        <MaterialTable style={{ minHeight: "auto" }}
                                            title=""
                                            columns={[
                                                { title: 'CEP', field: 'cep' },
                                                { title: 'Logradouro', field: 'logradouro' },
                                                { title: 'Número', field: 'numEndereco' },
                                                { title: 'Complemento', field: 'complemento' },
                                                { title: 'Bairro', field: 'bairro' },
                                                { title: 'Cidade', field: 'cidade' },
                                                { title: 'UF', field: 'uF' }
                                            ]}
                                            data={locais}
                                            isLoading={false}
                                            options={{
                                                selection: true
                                            }}
                                            onSelectionChange={(rows) => setLocaisExcluir(rows)}
                                            localization={table_translate}
                                        />
                                    </Col>
                                    <Col lg="6" className="text-left">
                                    </Col>
                                    <Col lg="6" className="text-right">
                                        {handleProximoStep != null &&
                                            <Button color="success" onClick={handleAvancar} className="btn-mobile" type="button">Próxima Etapa  <i className="fas fa-chevron-right"></i></Button>
                                        }
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}           